import { render, staticRenderFns } from "./shapes.vue?vue&type=template&id=98afa804&"
import script from "./shapes.vue?vue&type=script&lang=js&"
export * from "./shapes.vue?vue&type=script&lang=js&"
import style0 from "./shapes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('98afa804', component.options)
    } else {
      api.reload('98afa804', component.options)
    }
    module.hot.accept("./shapes.vue?vue&type=template&id=98afa804&", function () {
      api.rerender('98afa804', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/work/shapes.vue"
export default component.exports